import React, { useEffect } from 'react';
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Flex,
    FormControl,
    FormErrorMessage,
    useToast,
    Textarea
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { usePut } from '../../../../hooks';
import { IAppointment, ISummary } from '../../../../interfaces';
import { descriptionSummarySchema, descriptionSummarySchemaType } from './description-schema';

interface DescriptionModalProps {
    summary?: ISummary;
    isOpen: boolean;
    onClose: () => void;
    updateList: () => void;
}

export const DescriptionUpdateModal = (props: DescriptionModalProps): JSX.Element => {
    const { summary, isOpen, onClose, updateList} = props;
    const { doUpdate, loading, error, data } = usePut<IAppointment, { description: string }>(`/appointments/${summary?.appointment_id}/description`);

    const toast = useToast();

    console.log(summary?.description);

    const { register, handleSubmit, formState: { errors }, reset } = useForm<descriptionSummarySchemaType>({
        mode: 'onSubmit',
        reValidateMode: 'onSubmit',
        shouldFocusError: true,
        resolver: yupResolver(descriptionSummarySchema),
        criteriaMode: 'firstError',
        defaultValues: {
            description: summary?.description || '',
        }
    });

    useEffect(() => {
        if (summary) {
            reset({
                description: summary.description
            });
        }
    }, [summary]);

    useEffect(() => {
        if (!loading && Boolean(error)) {
            toast({
                description: error?.message || 'Error actualizando datos',
                status: 'error',
                duration: 9000,
                isClosable: true,
                position: 'bottom-right',
            });
        }
    }, [loading]);

    useEffect(() => {
        if(!loading && data) {
            updateList();
            toast({
                description: 'Datos actualizados exitosamente',
                status: 'success',
                duration: 9000,
                isClosable: true,
                position: 'bottom-right',
            });
            doClose();
        }
    }, [loading]);

    const onSubmit = (schema: descriptionSummarySchemaType): void => {
        if (summary && summary.appointment_id) {
            doUpdate({
                description: schema.description || ''
            });
        }
    };

    const doClose = (): void => {
        reset({
            description: '',
        });
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={doClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Actualizar Procedimientos</ModalHeader>
                <ModalCloseButton />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ModalBody>
                        <Flex flexDirection={{ base: 'column', md: 'row'}} my={1}>
                            <FormControl isInvalid={!!errors?.description?.message} mt={2} isDisabled={loading}>
                                <Textarea
                                    id="description"
                                    placeholder='Consulta, hematologia ...'
                                    focusBorderColor='primary.400'
                                    {...register('description', { required: true })}
                                />
                                <FormErrorMessage>
                                    {errors.description && errors.description.message}
                                </FormErrorMessage>
                            </FormControl>
                        </Flex>
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            type='submit'
                            ml={5}
                            color={'white'}
                            backgroundColor={'primary.300'}
                            _hover={{ backgroundColor: 'primary.300' }}
                        >
                            Actualizar
                        </Button>
                    </ModalFooter>
                </form>
            </ModalContent>
        </Modal>
    );
};
